<template>
  <router-link
    class="tutor-card"
    :to="{
      name: 'Courses',
      params: { id: tutor.id },
    }"
  >
    <div class="tutor-details">
      <div class="img-container">
        <img
          :src="tutor.profile_picture_url"
          :alt="tutor.full_name"
          class="tutor-img"
        />
        <div class="pills">
          <div class="pill">
            {{ institute_configs.currency_symbol }}
            {{ tutor.rate_per_hour }}
          </div>
          <div class="pill">
            <v-icon small color="#ffc759">mdi-star</v-icon>
            <span>{{ tutor.reviews }}</span>
          </div>
        </div>
      </div>
      <h3 class="name">{{ tutor.full_name }}</h3>
    </div>
    <div class="tutor-details-sm">
      <div class="img-container">
        <img
          :src="tutor.profile_picture_url"
          :alt="tutor.full_name"
          class="tutor-img"
        />
        <div>
          <h3 class="name">{{ tutor.full_name }}</h3>
          <div class="pills">
            <div class="pill">$ {{ tutor.rate_per_hour }}</div>
            <span></span>
            <div class="pill">
              <v-icon small color="#ffc759">mdi-star</v-icon>
              <span>{{ tutor.reviews }}</span>
            </div>
          </div>
          <!-- <a class="contact-tutor-btn">{{ $t("Contact the tutor") }}</a> -->
        </div>
      </div>
    </div>
    <div class="tutor-items">
      <div class="tutor-item">
        <img
          src="../../assets/images/tutors-list/translate.svg"
          alt="translate"
          class="icon"
        />
        <p class="tutor-desc">{{ tutor.languages.join(", ") }}</p>
      </div>
      <div class="tutor-item">
        <img
          src="../../assets/images/tutors-list/school.svg"
          alt="school"
          class="icon"
        />
        <p class="tutor-desc">{{ tutor.courses.join(", ") }}</p>
      </div>
      <div class="tutor-item">
        <img
          src="../../assets/images/tutors-list/person.svg"
          alt="person"
          class="icon"
        />
        <p class="tutor-desc">
          {{ tutor.student_count }}
          {{ $t(`Student${tutor.student_count === 1 ? "" : "s"}`) }}
        </p>
      </div>
    </div>
    <div class="actions">
      <button :id="`free-session-btn-${tutor.id}`" class="free-session-btn" @click.stop.prevent="navigateToCourses">
        {{ $t("freeTrialSession") }}
      </button>
      <button
        :id="`meet-tutor-btn-${tutor.id}`"
        class="meet-tutor-btn"
        @click.stop.prevent="contactTutorDialog = true"
      >
        {{ $t("meetYourTutor") }}
      </button>
      <!-- <a class="contact-tutor-btn">{{ $t("contactTheTutor") }}</a> -->
    </div>
    <Modal
      hideDefaultFooter
      hideDefaultHeader
      :isOpened="contactTutorDialog"
      :maxWidth="786"
      @closeModal="contactTutorDialog = false"
      transition="scale-transition"
    >
      <template #header>
        <header>
          <div>
            <div class="details-container">
              <img
                :src="tutor.profile_picture_url"
                :alt="tutor.full_name"
                class="profile-pic"
              />
              <div>
                <p class="contact-name">{{ tutor.full_name }}</p>
                <div class="pills">
                  <div class="pill">
                    {{ institute_configs.currency_symbol }}
                    {{ tutor.rate_per_hour }}
                  </div>
                  <span></span>
                  <div class="pill">
                    <v-icon small color="#ffc759">mdi-star</v-icon>
                    <span>{{ tutor.reviews }}</span>
                  </div>
                </div>
                <div class="tutor-items">
                  <div class="tutor-item">
                    <img
                      src="../../assets/images/tutors-list/translate.svg"
                      alt="translate"
                      class="icon"
                    />
                    <p class="tutor-desc">{{ tutor.languages.join(", ") }}</p>
                  </div>
                  <div class="tutor-item">
                    <img
                      src="../../assets/images/tutors-list/school.svg"
                      alt="school"
                      class="icon"
                    />
                    <p class="tutor-desc">{{ tutor.courses.join(", ") }}</p>
                  </div>
                  <div class="tutor-item">
                    <img
                      src="../../assets/images/tutors-list/person.svg"
                      alt="person"
                      class="icon"
                    />
                    <p class="tutor-desc">
                      {{ tutor.student_count }}
                      {{ $t(`Student${tutor.student_count === 1 ? "" : "s"}`) }}
                    </p>
                  </div>
                </div>
                <router-link
                  id="view-courses-btn"
                  class="view-courses-btn"
                  :to="{ name: 'Courses', params: { id: tutor.id } }"
                >
                  {{ $t("viewCourses") }}
                </router-link>
              </div>
            </div>
            <div class="tutor-items">
              <div class="tutor-item">
                <img
                  src="../../assets/images/tutors-list/translate.svg"
                  alt="translate"
                  class="icon"
                />
                <p class="tutor-desc">{{ tutor.languages.join(", ") }}</p>
              </div>
              <div class="tutor-item">
                <img
                  src="../../assets/images/tutors-list/school.svg"
                  alt="school"
                  class="icon"
                />
                <p class="tutor-desc">{{ tutor.courses.join(", ") }}</p>
              </div>
              <div class="tutor-item">
                <img
                  src="../../assets/images/tutors-list/person.svg"
                  alt="person"
                  class="icon"
                />
                <p class="tutor-desc">
                  {{ tutor.student_count }}
                  {{ $t(`Student${tutor.student_count === 1 ? "" : "s"}`) }}
                </p>
              </div>
            </div>
            <router-link
              class="view-courses-btn"
              :to="{ name: 'Courses', params: { id: tutor.id } }"
            >
              {{ $t("viewCourses") }}
            </router-link>
          </div>
          <v-icon
            color="#1C1B1F"
            class="justify-self-end"
            @click.stop.prevent="contactTutorDialog = false"
          >
            mdi-close
          </v-icon>
        </header>
      </template>
      <template #body>
        <div class="meet-section" v-if="tutor.video_documents.length">
          <h2 class="meet-title ">Meet your Tutor</h2>
          <video
            :id="`video-${video.id}`"
            v-for="video in tutor.video_documents"
            :key="video.id"
            :src="video.file_url"
            translate
            controls
            preload
          />
        </div>
        <div class="no-videos" v-else>
          {{ $t("tutorHasNoAvailableVideos") }}
        </div>
      </template>
    </Modal>
  </router-link>
</template>

<script>
import GlobalMixin from "../../GlobalMixin";
import Modal from "../global/Modal.vue";
import Header from "../Header.vue";
// import { findFlagUrlByNationality } from "country-flags-svg";

export default {
  name: "TutorCard",
  mixins: [GlobalMixin],
  props: ["tutor"],
  components: {
    Modal,
    Header,
  },
  data() {
    return {
      institute_configs: JSON.parse(localStorage.getItem("institute_configs")),
      contactTutorDialog: false,
    };
  },
  mounted() {
    window.addEventListener("localstorageChange", (event) => {
      this.institute_configs = JSON.parse(
        event.detail.storage.institute_configs
      );
    });
  },
  methods: {
    navigateToCourses() {
      this.$router.push({
        name: "Courses",
        params: { id: this.tutor.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tutor-card {
  font-family: $font-family;
  padding: 16px;
  outline: 1px solid #b4bbc5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  &:hover {
    outline: 2px solid $green;
  }
  .tutor-details {
    display: block;
    .img-container {
      position: relative;
      .tutor-img {
        display: inline-block;
        margin-bottom: 16px;
        width: 100%;
        max-height: 205px;
        aspect-ratio: 1/1;
        border-radius: 4px;
        object-fit: fill;
      }
      .pills {
        display: flex;
        gap: 4px;
        position: absolute;
        top: 4px;
        left: 4px;
        .pill {
          background: $white;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 2px;
          border: 1px solid #0f9918;
          border-radius: 100px;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 100%;
          letter-spacing: 0.01rem;
          text-transform: uppercase;
          color: #0f9918;
          &:first-child {
            padding: 6px 12px;
          }
          &:last-child {
            padding: 6px 8px;
          }
        }
      }
    }
  }
  .name {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #061c3d;
    margin-bottom: 8px;
  }
  .tutor-details-sm {
    display: none;
  }
  .tutor-items {
    margin-bottom: 10px;
    .tutor-item {
      display: flex;
      align-items: center;
      gap: 4px;
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      .icon {
        width: 1rem;
        height: 1rem;
      }
      .tutor-desc {
        color: $description;
        font-weight: 300;
        font-size: 0.75rem;
        line-height: 1rem;
        margin: 0;
      }
    }
  }
  .actions {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    button {
      padding: 8px;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.5rem;
      text-align: center;
      text-transform: capitalize;
      border-radius: 8px;
      width: 100%;
      &.free-session-btn {
        display: block;
        color: $white;
        background: $green;
        &:hover {
          background: $hover-green;
        }
      }
      &.meet-tutor-btn {
        display: block;
        border: 1px solid $green;
        color: $green;
        &:hover {
          color: $hover-green;
          border: 1px solid $hover-green;
        }
      }
    }
  }
  a {
    display: block;
    text-decoration: none;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.5rem;
    text-transform: capitalize;
    color: $green;
    &:hover {
      color: $hover-green;
    }
  }
}
header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 25px;
  padding: 25px 0;
  padding-inline-end: 20px;
  padding-inline-start: 50px;
  font-size: 16px;
  div {
    .details-container {
      display: flex;
      flex-direction: row;
      gap: 24px;
      .profile-pic {
        display: block;
        text-align: center;
        width: 181px;
        max-height: 181px;
        border-radius: 8px;
        object-fit: fill;
      }
      div {
        display: flex;
        flex-direction: column;
        gap: 8px;
        .contact-name {
          font-weight: 500;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #061c3d;
          margin: 0;
        }
        .pills {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-direction: row;
          .pill {
            width: 100px;
            font-weight: 400;
            font-size: 0.6875rem;
            text-transform: uppercase;
            color: #5fd068;
            border: 1px solid #5fd068;
            border-radius: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: row;
            padding: 4.5px;
          }
          & > span {
            height: 14px;
            border-right: 1px solid #e6e8ec;
          }
        }
        .tutor-items {
          display: block;
          .tutor-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 4px;
            &:not(:last-child) {
              margin-bottom: 8px;
            }
            .icon {
              width: 1rem;
              height: 1rem;
            }
            .tutor-desc {
              color: $description;
              font-weight: 300;
              font-size: 1rem;
              line-height: 1rem;
              margin: 0;
            }
          }
        }
        .view-courses-btn {
          display: block;
          text-align: center;
          text-decoration: none;
          padding: 8px 0;
          width: 100%;
          background: $green;
          border-radius: 8px;
          font-weight: 500;
          font-size: 1em;
          line-height: 1.5em;
          color: $white;
          &:hover {
            background: $hover-green;
          }
        }
      }
    }
    .tutor-items {
      display: none;
      .tutor-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        .icon {
          width: 1rem;
          height: 1rem;
        }
        .tutor-desc {
          color: $description;
          font-weight: 300;
          font-size: 1rem;
          line-height: 1rem;
          margin: 0;
        }
      }
    }
    .view-courses-btn {
      display: none;
      text-align: center;
      padding: 8px 0;
      width: 100%;
      background: $green;
      border-radius: 8px;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.5rem;
      color: $white;
      &:hover {
        background: $hover-green;
      }
    }
  }
}
.no-videos {
  padding: 25px 50px;
  text-align: center;
  font-size: 2rem;
}
.meet-section {
  padding: 32px;
  font-weight: 500;
  line-height: 1.75rem;
  color: #061c3d;
  font-size: 1rem;
  .meet-title {
    font-size: 1.25rem;
    margin-bottom: 16px;
  }
  video {
    border-radius: 8px;
    width: 100%;
  }
  & video:not(:last-of-type) {
    margin-bottom: 25px;
  }
}
@media all and (min-width: $min-md-screen) and (max-width: $max-md-screen) {
  .tutor-card {
    padding: 16px 11px;
    font-size: 0.875rem;
    .img-container {
      .tutor-img {
        max-height: 146px;
      }
    }
    .tutor-items {
      margin-bottom: 8px;
      .tutor-item {
        font-size: 1rem;
        .icon {
          width: 1rem;
          height: 1rem;
        }
        .tutor-desc {
          font-size: 0.75rem;
          line-height: 1rem;
        }
      }
    }
    .actions {
      font-size: 1rem;
      button {
        display: block;
        font-size: 0.875rem;
        line-height: 1.5rem;
      }
      a {
        display: block;
        font-size: 0.875rem;
        line-height: 1.5rem;
      }
    }
  }
}
@media all and (max-width: $min-md-screen) {
  .tutor-card {
    padding: 16px;
    .tutor-details {
      display: none;
    }
    .tutor-details-sm {
      display: block;
      margin-bottom: 12px;
      .img-container {
        display: flex;
        gap: 16px;
        img {
          width: 80px;
          height: 80px;
          border-radius: 4px;
        }
        div {
          .pills {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 5px;
            .pill {
              font-weight: 400;
              font-size: 0.6875rem;
              text-transform: uppercase;
              color: #5fd068;
              &:first-child {
                padding: 4.5px 25px 4.5px 4px;
              }
              &:last-child {
                padding: 4px 13.5px;
                display: flex;
                gap: 7px;
              }
            }
            & > span {
              height: 14px;
              border-right: 1px solid #e6e8ec;
            }
          }
        }
      }
    }
    .name {
      font-size: 0.75rem;
      margin-bottom: 11px;
    }
    .actions {
      display: flex;
      flex-direction: row;
      gap: 8px;
      button {
        font-size: 0.75rem;
      }
      a {
        display: none;
      }
    }
  }
  header {
    gap: 16px;
    padding: 16px;
    font-size: 0.875rem;
    div {
      .details-container {
        margin-bottom: 10px;
        gap: 16px;
        .profile-pic {
          width: 80px;
          height: 80px;
          object-fit: contain;
          aspect-ratio: 1/1;
        }

        div {
          gap: 8px;
          .contact-name {
            font-size: 1rem;
            line-height: 1.28rem;
          }
          .pills {
            gap: 8px;
            .pill {
              width: 70px;
              font-size: 0.75rem;
            }
          }
          .tutor-items {
            display: none;
          }
          .view-courses-btn {
            display: none;
          }
        }
      }
      .tutor-items {
        display: block;
        margin-bottom: 10px;
        .tutor-item {
          display: flex;
          align-items: center;
          gap: 4px;
          &:not(:last-child) {
            margin-bottom: 8px;
          }
          .icon {
            width: 1rem;
            height: 1rem;
          }
          .tutor-desc {
            color: $description;
            font-family: $font-family;
            font-weight: 300;
            font-size: 0.85rem;
            line-height: 1rem;
            margin: 0;
          }
        }
      }
      .view-courses-btn {
        display: block;
        text-decoration: none;
        padding: 8px 0;
        width: 100%;
        background: $green;
        border-radius: 8px;
        font-weight: 500;
        font-size: 0.85rem;
        line-height: 1.5rem;
        color: $white;
        &:hover {
          background: $hover-green;
        }
      }
    }
  }
  .no-videos {
    font-size: 1.5em;
  }
  .meet-section {
    padding: 25px 16px;

    .meet-title {
      font-size: 0.875rem;
      margin-bottom: 16px;
    }
    video {
      border-radius: 8px;
    }
    & video:not(:last-of-type) {
      margin-bottom: 25px;
    }
  }
}
</style>
